(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tiny-shiny-chat"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tiny-shiny-chat')) customElements.define('tiny-shiny-chat',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  const panel=this.querySelector('.ts-panel'),launch=this.querySelector('.ts-launch'),input=this.querySelector('input'),form=this.querySelector('form'),log=this.querySelector('.ts-log');
  const scroll=()=>{log.scrollTop=log.scrollHeight;};
  const say=(text,user=false)=>{const p=document.createElement('p');p.textContent=text;if(user)p.className='ts-user';log.append(p);scroll();return p;};
  const link=(label,url)=>{const a=document.createElement('a');a.className='ts-link';a.textContent=label;a.href=url;log.append(a);scroll();};
  const root=this.dataset.root.replace(/\/?$/,'/');
  const support=()=>link('Continue on WhatsApp','https://sku.tinyshinygifts.com/api/whatsapp/support');
  const track=()=>{say('For your privacy, sign in to view your orders and tracking, or open the tracking link in your order confirmation email. For WhatsApp tracking, send TRACK followed by your order number from the phone used for the order.');link('View my orders',this.dataset.account);support();};
  const close=()=>{panel.hidden=true;launch.setAttribute('aria-expanded','false');launch.focus();};
  launch.onclick=()=>{panel.hidden=!panel.hidden;launch.setAttribute('aria-expanded',String(!panel.hidden));if(!panel.hidden)input.focus();};
  this.querySelector('.ts-close').onclick=close;
  this.onkeydown=e=>{if(e.key==='Escape'&&!panel.hidden)close();};
  this.querySelector('.ts-actions').onclick=e=>{const action=e.target.closest('button')?.dataset.action;if(action==='track')track();if(action==='support')support();if(action==='products'){say('Type a product name, for example Shiva, to see matching products.');input.focus();}if(action==='returns'){say('Please check our policies for delivery and return conditions.');log.append(this.querySelector('template').content.cloneNode(true));support();scroll();}};
  form.onsubmit=async e=>{
   e.preventDefault();const q=input.value.trim();if(q.length<2)return;input.value='';say(q,true);
   if(/^(track|tracking|order status|mera order|order kaha)\b/i.test(q)){track();return;}
   if(/^(help|support|whatsapp|agent|human)$/i.test(q)){support();return;}
   const pending=say('Finding products�');const submit=form.querySelector('button');submit.disabled=true;const controller=new AbortController();const timeout=setTimeout(()=>controller.abort(),10000);
   try{
    const url=new URL(root+'search/suggest.json',location.origin);url.search=new URLSearchParams({q,'resources[type]':'product','resources[limit]':'4','resources[options][unavailable_products]':'last'});
    const response=await fetch(url,{signal:controller.signal});if(!response.ok)throw Error('Search unavailable');const data=await response.json();const products=data.resources?.results?.products||[];pending.textContent=products.length?'Here are matching products. Open a product for its current price, options and availability.':'No matching products found. Try another name.';
    for(const product of products){const dest=new URL(product.url,location.origin);if(dest.origin!==location.origin)continue;const a=document.createElement('a');a.className='ts-product';a.href=dest.href;const src=product.featured_image?.url||product.image;if(src){const imageUrl=new URL(src,location.origin);if(imageUrl.protocol==='https:'){const img=document.createElement('img');img.src=imageUrl.href;img.alt=product.title;img.loading='lazy';img.width=80;img.height=80;a.append(img);}}const text=document.createElement('span');text.textContent=product.title+(product.available===false?' � Sold out':'');a.append(text);log.append(a);}
    const all=new URL(root+'search',location.origin);all.search=new URLSearchParams({q,type:'product'});link('See all matching products',all.href);
   }catch{pending.textContent='Product search is temporarily unavailable. Please try store search below.';const all=new URL(root+'search',location.origin);all.search=new URLSearchParams({q,type:'product'});link('Search store',all.href);}
   finally{clearTimeout(timeout);submit.disabled=false;scroll();}
  };
 }
});

  } catch(e) { console.error(e); }
})();
})();
